import { memo } from 'react'
import campaigningToll from '../assets/images/campaigning.png';

function Preloader({action = false}) {
  return (
    <div id="preloader" className={action ? 'd-flex justify-content-center align-items-center' : 'd-none'}>
      <img src={campaigningToll} style={{width: '55px'}}/>
    </div>
  )
}

export default memo(Preloader);
